export default "__VITE_ASSET__Cvv6ejtc__"